import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Keeps sibling colour links aligned with the selected native product variant. */
class LussommoProductColours extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    if (this.#controller.signal.aborted) this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, this.#updateLinks, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  /** @param {import('./events').VariantUpdateEvent} event */
  #updateLinks = (event) => {
    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) return;
    const source = event.detail.data.html;
    const newPicker = source?.querySelector(`lussommo-product-colours[data-block-id="${this.dataset.blockId}"]`);
    if (!newPicker) return;
    const newLinks = Array.from(newPicker.querySelectorAll('a[data-colour-product-id]'));
    for (const link of this.querySelectorAll('a[data-colour-product-id]')) {
      if (!(link instanceof HTMLAnchorElement)) continue;
      const updatedLink = newLinks.find((candidate) => candidate.dataset.colourProductId === link.dataset.colourProductId);
      if (updatedLink instanceof HTMLAnchorElement) link.href = updatedLink.href;
    }
  };
}

if (!customElements.get('lussommo-product-colours')) {
  customElements.define('lussommo-product-colours', LussommoProductColours);
}
